import React from "react";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import { useSelector } from "react-redux";

export default function PromptNavigationModal({ content, isClose = false }) {
  const { responsive } = useSelector((state) => state.app);

  return (
    <ModalWrapper
      size="tiny"
      style={{
        width: !responsive.isMobile ? "fit-content" : "98%",
        padding: 20,
      }}
      modalClassName="modal-ux-wrapper"
      showAnimation={"fade"}
      hideAnimation={"fade"}
      showDuration={200}
      hideDuration={200}
      closeOnEscape={isClose}
      closeOnDimmerClick={isClose}
      closeIcon={isClose}
    >
      {content}
    </ModalWrapper>
  );
}
